export default Object.freeze({
    RECEIVED: 'received',
    MADE: 'made',
})
